import { InitAnchorScrollSpy } from "@components/General/AnchorScrollSpy/anchorScrollSpy.component";
import { InitBreadcrumb } from "@components/General/Breadcrumb/breadcrumb.component";
import { InitPageLink } from "@components/General/PageLinks/AemPageLink/pageLink.component";
import { InitModal } from "@components/Modals/Modal/modal.component";
import { InitNavigation } from "@components/Navigation/navigation.component";
import { InitFeatureList } from "@components/ProductPage/info/featureList/featureList.component";
import { InitInfoBlock } from "@components/ProductPage/info/infoBlock/infoBlock.component";

const init = () => {
    InitAnchorScrollSpy();
    InitBreadcrumb();
    InitNavigation();
    InitFeatureList();
    InitInfoBlock();
    InitModal();
    InitPageLink();
};

export { init };
